import React from 'react'
import SlotsSummaryChart from './SlotsSummaryChart'
import HourChart from './HourChart'
import BoxMap from './BoxMap'
import { Card, Flex } from 'antd'
import SlotEventsChart from './SlotEventsChart'
import PostalPlaceFilledChart from './PostalPlaceFilledChart'

export default function SingleBoxCharts (slots, selectedBox) {
  const groupedCharts = (charts) => (
    <Card>
      <Flex justify='space-around'>
        {charts.map(Chart => <Chart slots={slots.filter(slot => slot.type === 'PatientSlot' && slot.state === 'done')} key={Chart.toString()} />)}
      </Flex>
    </Card>
  )

  return [
    { key: 'slotSummary', children: (<SlotsSummaryChart slots={slots} />) },
    { key: 'slotHour', children: (<HourChart slots={slots} />) },
    { key: 'boxMap', children: (<BoxMap slots={slots.filter(slot => slot.type === 'PatientSlot' && slot.state === 'done')} selectedBox={selectedBox} />) },
    { key: 'groupedCharts1', children: (groupedCharts([SlotEventsChart, PostalPlaceFilledChart])) }
  ]
}
